const BREAK_POINTS = {
  base: '0em', // 0px
  sm: '30em', // 480px
  md: '48em', // 768px
  lg: '62em', // 992px
  xl: '80em', // 1280px
  '2xl': '96em', // 1536px
};

export const BREAK_POINT_ORDER = ['2xl', 'xl', 'lg', 'md', 'sm', 'base'];

export const QUERY_BREAK_POINT = BREAK_POINT_ORDER.map(
  breakPoint => `(min-width: ${BREAK_POINTS[breakPoint]})`,
);
